var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ReportTable',{staticClass:"mb-10 mt-4",attrs:{"items":_vm.income.data,"headers":_vm.headers,"title":"Przychód","table-name":"incomeReport","report":"income"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }